var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"activities-agenda-list"}},[_c('Breadcrumbs',{attrs:{"breadcrumbs":[
    { title: this.$t(`menu.${this.serviceSlug}`)},
    { title: this.$t('activities_agenda.list.title'), disabled: true }
  ]}}),_c('div',{staticClass:"list"},[_c('TableView',{attrs:{"service":_vm.component.service,"component":_vm.component,"serviceSlug":_vm.serviceSlug}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }